import { CoreBox, CoreTypography } from '@youscience/core';
import { CircularProgress } from '@mui/material';

import { ProfileData } from '@components/GatherPersonalInfo/GatherPersonalInfo';
import { sxStyles } from './SummaryContent.styles';

const renderSummaryItem = (title: string, value: string) => {
  return (
    <CoreBox sx={sxStyles.summaryItemWrap}>
      <CoreTypography data-testid="summaryItemTitle" variant="h6" component="h5">
        {title}
      </CoreTypography>

      <CoreTypography data-testid="summaryContentValue">{value}</CoreTypography>
    </CoreBox>
  );
};

const otherCollege: { [key: string]: string } = {
  inOverAYear: 'In over a year',
  notSure: 'Not Sure',
};

export interface SummaryContentProps {
  summaryTitle?: string;
  profileData: ProfileData;
}

export const SummaryContent = (props: SummaryContentProps) => {
  const { profileData, summaryTitle } = props;

  const alreadyGraduated = !!(
    (profileData.gradeLevel == -1 || !profileData.gradeLevel) &&
    (profileData.plan?.now || profileData.plan?.next?.length)
  );

  return (
    <>
      <CoreBox sx={sxStyles.loaderWrap}>
        <CoreTypography data-testid="summaryContentTitle" sx={sxStyles.subtitle}>
          {summaryTitle}
        </CoreTypography>

        <CircularProgress data-testid="summaryContentLoader" />
      </CoreBox>

      <CoreBox>
        {renderSummaryItem(
          'Your grade',
          alreadyGraduated
            ? 'Already Graduated'
            : `${profileData.gradeLevel}th${
                profileData.graduationYear && !isNaN(profileData.graduationYear)
                  ? `, graduating in ${profileData.graduationYear}`
                  : ''
              }`,
        )}

        {profileData.beginCollegeOther
          ? renderSummaryItem('College enrollment plan', `${otherCollege[profileData.beginCollegeOther]}`)
          : renderSummaryItem(
              'Plan on enrolling',
              `${profileData.beginCollegeSeason}, ${profileData.beginCollegeYear}`,
            )}
      </CoreBox>
    </>
  );
};
